export const TransparentCloseIcon = () => (
  <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='24' cy='24' r='24' fill='black' fillOpacity='0.25' />
    <circle
      cx='24'
      cy='24'
      r='22.6667'
      stroke='#999999'
      strokeOpacity='0.3'
      strokeWidth='2.66667'
    />
    <path d='M16 16L32 32' stroke='#CCCCCC' strokeWidth='2.66667' strokeLinecap='round' />
    <path d='M32 16L16 32' stroke='#CCCCCC' strokeWidth='2.66667' strokeLinecap='round' />
  </svg>
)
